import type { ConditionData } from "@qendo/medical/condition";
import { MedicalType } from "@qendo/medical/types";
import Data from "~/util/data";

export class Condition extends Data implements ConditionData {
    public readonly type = MedicalType.condition;

    public constructor(
        public id?: string,
        public description: string | null = null,
        public option_id: string | null = null,
        public photograph_ids: string[] = [],
        public confirmed = false,
        public primary = false,
    ) {
        super();
    }
}
